import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { type WorkerHasNotPassedAssessmentBookabilityUnmetCriteriaMetadata } from "@src/appV2/OpenShifts/ShiftAction/types";
import { SKILLS_ASSESSMENT_BASE_PATH } from "@src/appV2/SkillsAssessment/paths";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

interface Props {
  metadata: WorkerHasNotPassedAssessmentBookabilityUnmetCriteriaMetadata;
}

export function ClipboardOrientationRequiredCard(props: Props) {
  const {
    metadata: { qualificationName, qualificationId },
  } = props;

  const history = useHistory();

  useLogEffect(APP_V2_USER_EVENTS.CLIPBOARD_ORIENTATION_REQUIRED_DIALOG_VIEWED, {
    qualificationName,
    qualificationId,
  });

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title="Demo Shift required"
      description="To book this shift, complete a quick virtual walkthrough."
      illustrationType="calendar-alert"
      footer={
        <Button
          fullWidth
          variant="contained"
          size="medium"
          onClick={() => {
            logEvent(
              APP_V2_USER_EVENTS.CLIPBOARD_ORIENTATION_REQUIRED_DIALOG_CONTINUE_BUTTON_CLICKED,
              {
                qualificationName,
                qualificationId,
              }
            );

            history.push(SKILLS_ASSESSMENT_BASE_PATH);
          }}
        >
          Continue
        </Button>
      }
    />
  );
}
